export enum AuthSteps {
  ENTER_EMAIL,
  ENTER_EXISTING_PASS,
  REGISTER_NEW_ACCOUNT
}